const texts = {
    "print-invoice": {
        EN: "Print customs invoice",
        DA: "Udskriv toldfaktura",
        DE: "Zollrechnung drucken",
        NL: "Douanefactuur afdrukken",
        FR: "Imprimer la facture douanière",
        IT: "Stampa la fattura doganale",
        ES: "Imprimir factura de aduana",
        PT: "Imprimir fatura alfandegária",
        FI: "Tulosta tullilasku",
        SV: "Skriv ut tullfaktura",
        NO: "Skriv ut tollfaktura",
    },

    "print-invoice-dont-forget": {
        EN: "You also need to print the customs invoice",
        DA: "Du skal også udskrive toldfakturaen",
        DE: "Sie müssen auch die Zollrechnung drucken",
        NL: "Je moet ook de douanefactuur afdrukken",
        FR: "Vous devez également imprimer la facture douanière",
        IT: "Devi anche stampare la fattura doganale",
        ES: "También necesitas imprimir la factura de aduana",
        PT: "Você também precisa imprimir a fatura alfandegária",
        FI: "Sinun täytyy myös tulostaa tullilasku",
        SV: "Du behöver också skriva ut tullfakturan",
        NO: "Du må også skrive ut tollfakturaen",
    },

    "print-invoices": {
        EN: "Print ${amount} customs invoices",
        DA: "Udskriv ${amount} toldfakturaer",
        DE: "${amount} Zollrechnungen drucken",
        NL: "Druk ${amount} douanefacturen af",
        FR: "Imprimer ${amount} factures douanières",
        IT: "Stampa ${amount} fatture doganali",
        ES: "Imprimir ${amount} facturas de aduana",
        PT: "Imprimir ${amount} faturas alfandegárias",
        FI: "Tulosta ${amount} tullilaskua",
        SV: "Skriv ut ${amount} tullfakturor",
        NO: "Skriv ut ${amount} tollfakturaer",
    },

    "print-invoice-fee": {
        EN: `Note that you need to print and add the return p{customs invoice|customs invoices} to the package, or a b{50 USD fee} will be added`,
        DA: `Bemærk at du skal udskrive og tilføje retur p{toldfaktura|toldfakturaer} til pakken, ellers tilføjes et b{50 USD gebyr}`,
        DE: `Beachten Sie, dass Sie die Rücksende p{Zollrechnung|Zollrechnungen} drucken und dem Paket beilegen müssen, sonst wird eine b{50 USD Gebühr} hinzugefügt`,
        NL: `Let op: je moet de retour p{douanefactuur|douanefacturen} afdrukken en aan het pakket toevoegen, anders wordt er een b{50 USD tarief} toegevoegd`,
        FR: `Notez que vous devez imprimer et ajouter p{la facture douanière|les factures douanières} de retour au colis, sinon b{des frais de 50 USD} seront ajoutés`,
        IT: `Nota che devi stampare e aggiungere p{la fattura doganale|le fatture doganali} di reso al pacco, oppure verrà aggiunta b{una tariffa di 50 USD}`,
        ES: `Ten en cuenta que debes imprimir y agregar p{la factura de aduana|las facturas de aduana} de devolución al paquete, o se añadirá b{una tarifa de 50 USD}`,
        PT: `Observe que você precisa imprimir e adicionar p{a fatura alfandegária|as faturas alfandegárias} de devolução ao pacote, ou b{uma taxa de 50 USD} será adicionada`,
        FI: `Huomaa että sinun täytyy tulostaa ja lisätä palautus p{tullilasku|tullilaskut} pakettiin, tai b{50 USD maksu} lisätään`,
        SV: `Observera att du måste skriva ut och lägga retur p{tullfaktura|tullfakturor} i paketet, annars tillkommer b{50 USD i avgift}`,
        NO: `Merk at du må skrive ut og legge ved retur p{tollfaktura|tollfakturaer} i pakken, ellers legges det til b{50 USD i gebyr}`,
    },

    print: {
        EN: "Print",
        DA: "Udskriv",
        DE: "Drucken",
        NL: "Afdrukken",
        FR: "Imprimer",
        IT: "Stampa",
        ES: "Imprimir",
        PT: "Imprimir",
        FI: "Tulosta",
        SV: "Skriv ut",
        NO: "Skriv ut",
    },

    "pdf-not-automatically-printed": {
        EN: "PDF did not automatically print? Click here",
        DA: "PDF blev ikke automatisk udskrevet? Klik her",
        DE: "PDF wurde nicht automatisch gedruckt? Hier klicken",
        NL: "PDF niet automatisch afgedrukt? Klik hier",
        FR: "Le PDF ne s'est pas imprimé automatiquement? Cliquez ici",
        IT: "Il PDF non è stato stampato automaticamente? Clicca qui",
        ES: "¿El PDF no se imprimió automáticamente? Haz clic aquí",
        PT: "O PDF não foi impresso automaticamente? Clique aqui",
        FI: "PDF ei tulostunut automaattisesti? Klikkaa tästä",
        SV: "Skrevs PDF:en inte ut automatiskt? Klicka här",
        NO: "Ble ikke PDF-en skrevet ut automatisk? Klikk her",
    },
};

export default texts;
